<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title v-if="mode==='create'">Create Master Data</md-dialog-title>
      <md-dialog-title v-if="mode==='update'">Update Master Data</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSave">

        <div id="masterData">
          <md-field :class="getValidationClass('dataForm.group')">
            <label>Group</label>
            <md-input v-model="dataForm.group" disabled/>
            <!--<span class="md-error" v-if="!$v.dataForm.group.required">Group is required</span>-->
          </md-field>

          <!--
          <md-field :class="getValidationClass('dataForm.tagId')">
            <label>Tag Id</label>
            <md-input v-model="dataForm.tagId"/>
            <span class="md-error" v-if="!$v.dataForm.tagId.required">Tag Id is required</span>
          </md-field>

          <md-field :class="getValidationClass('dataForm.tagName')">
            <label>Tag Name</label>
            <md-input v-model="dataForm.tagName"/>
            <span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>
          </md-field>
          -->
          <div>
              <md-field>
                <label>Transloading Yard</label>
                <md-input v-model="dataForm.transYard" disabled />
              </md-field>

          </div>
          <div>
            <!-- 2nd col -->
            <div class = "inputBoxInbound" >
              <auto-complete-master-data-select
                                                group="REC_WINDOW"
                                                label="Receiving Windows"
                                                :init-value="dataForm.recWindow"
                                                :watchValueId="dataForm.recWindow"
                                                :on-item-changed="handleWindowsChanged"
                                                >
            </auto-complete-master-data-select>
            </div>

            
          </div>

            <!--<div class = "layout">-->
                <md-field>
                <label for="apptInTime">Appointment Time</label>
                <md-input name="apptInTime"
                        id="apptInTime"
                        autocomplete="new-password"
                        v-model="dataForm.from"
                        placeholder="Format: HH:MM:SS"
                />
                <span class="md-error" v-if="!$v.dataForm.from.add">
                   Appt time format is invalid!
                 <br/></span>  
                </md-field>
            <!--</div>-->

            <div class = "inputBoxInbound" >
              <auto-complete-master-data-select
                                                group="EXT_TRUCKER"
                                                label="External Trucker"
                                                :init-value="dataForm.extTrucker"
                                                :watchValueId="dataForm.extTrucker"
                                                :on-item-changed="handleExtTruckerChanged"
                                                >
            </auto-complete-master-data-select>
            </div>

          <md-field :class="getValidationClass('dataForm.occurence')">
            <label>Occurence</label>
            <md-input v-model="dataForm.occurence"/>
            <!--<span class="md-error" v-if="!$v.dataForm.tagName.required">Tag Name is required</span>-->
          </md-field>

          <md-switch v-model="dataForm.active">Active</md-switch>
        </div>

          <calling-api type="bar" path="/api/w/masterData/update">

            <md-dialog-actions>
              <md-button class="md-primary" @click="closeDialog();showDialog = false">Close</md-button>
              <md-button type="submit" class="md-primary">Save</md-button>
            </md-dialog-actions>

          </calling-api>


        </form>

      </md-dialog-content>
    </md-dialog>
  </div>
</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
  }
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { required, } from 'vuelidate/lib/validators';
  import DatePicker from './DatePicker.vue';
  import moment from 'moment';

  const getInitialDataForm = () => ({
    group: "T_APP_MASTER",
    tagId: null,
    tagName: null,
    active: true,
    recWindow: null,
    recWindowDesc: null,
    from: null,
    to: null,
    transYard: "1010001",
    weekDay: null,
    weekDayDesc: null,
    occurence: 1,
    extTrucker: null,
    extTruckerId: null,
    dockType: null
  });

  const getInitialSaveData = () => ({
    group: "T_APP_MASTER",
    tagId: null,
    tagName: null,
    active: true,
    recWindow: null,
    recWindowDesc: null,
    from: null,
    to: null,
    transYard: "1010001",
    weekDay: null,
    weekDayDesc: null,
    occurence: 1,
    extTrucker: null,
    extTruckerId: null,
    dockType: null
  });

  export default {
  components: { DatePicker },
    mixins: [validationMixin],
    props: {
      mode: String,
      onUpdate: Function,
    },
    data: () => ({
      showDialog: false,
      stores: [],
      dispatchers: [],
      dataForm: getInitialDataForm(),
      saveData: getInitialSaveData(),
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getSaleOfficeMasterData',
        'getPermission'
      ]),
      getDispatcherInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        return `${this.dataForm.dispatcherName} (${this.dataForm.dispatcherId})`;
      },
      getSpecialStatusInitValue() {
        if (this.mode === 'create') {
          return null;
        }
        return `${this.dataForm.statusName} (${this.dataForm.statusId})`;
      },
    },
    watch: {},
    validations: {
      dataForm: {
        group: {
          required,
        },
        tagId: {
          required,
        },
        tagName: {
          required,
        },
        from:{
            add : (value) => {
              //var hour = value.toString().substr(1,value.indexOf(":"));
              if (value != null) {
              if (value.indexOf(":") > -1 && value.length >= 1) {
                 console.log("hour: " + value.substr(0,value.indexOf(":")));
                 console.log("min: " + value.substr(value.indexOf(":")+1))
                 var hour = value.substr(0,value.indexOf(":"));
                 var min = value.substr(value.indexOf(":")+1);
                 if (hour.length == 1) hour = "0" + hour;
                 if (min.length == 1) min = "0" + min;
              }
              var setDate = "2021-04-01T" + hour + ":" + min + ":00"; 
              const res = moment(setDate).toDate();
              console.log("appt time: " + value + " setDate: " + setDate + " rec: " + res);
              return res != 'Invalid Date';
              }
              else 
                return "";
            }
        },
      },
    },
    methods: {
      //openDialog(existingData) {
      openDialog(updateItem) {         
        this.dataForm = getInitialDataForm();
        this.$v.dataForm.$reset();

        if (this.mode === "Update")
        {
          if (updateItem)
          {
            console.log("item - tagId: " + updateItem.tagId + " tagName: " + updateItem.tagName);
            console.log("item - group: " + updateItem.group);
             console.log("item-recWindow: " + updateItem.recWindow);
             console.log("item-extTrucker: " + updateItem.extTrucker);
             console.log("item-from: " + updateItem.from);
             this.dataForm.recWindow = updateItem.recWindow;
             //this.handleExtTruckerChanged(updateItem.extTrucker);
             this.handleExtTruckerChanged(updateItem.extTruckerId);
             if (updateItem.extTruckerId && updateItem.extTruckerId != "")
             {
                this.dataForm.extTrucker = this.getMasterDataName("EXT_TRUCKER",this.dataForm.extTruckerId);
             }
             this.dataForm.from = updateItem.from;
             this.dataForm.to = updateItem.to;
             this.dataForm.recWindowDesc = updateItem.recWindowDesc;
             this.dataForm.weekDay = updateItem.weekDay;
             this.dataForm.weekDayDesc = updateItem.weekDayDesc;
             this.dataForm.dockType = updateItem.dockType;
             this.dataForm.tagId = updateItem.tagId;
             this.dataForm.tagName = updateItem.tagName;
             this.dataForm.group = updateItem.group;
             this.dataForm.active = updateItem.active;
          }
        }
        this.showDialog = true;
      },
      closeDialog(){
        console.log("ext trucker: " + this.dataForm.extTrucker);
        console.log("ext trucker id: " + this.dataForm.extTruckerId);
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      handleWindowsChanged(id) {
        this.dataForm.recWindow = id;
      },
      handleExtTruckerChanged(id) {
        //var trucker = this.getMasterDataName("EXT_TRUCKER",id);
        console.log("item External Trucker id: " + id);
        //console.log("name in item: " + trucker);
        
        this.dataForm.extTruckerId = id;
        //this.dataForm.extTrucker = trucker;
      },

      showinternalData() {
          console.log("group: " + this.dataForm.group);
          console.log("tagId: " + this.dataForm.tagId);
          console.log("tagName: " + this.dataForm.tagName);
          console.log("active: " + this.dataForm.active);
          console.log("recWindow: " + this.dataForm.recWindow);
          console.log("recWindowDesc: " + this.dataForm.recWindowDesc);
          console.log("from: " + this.dataForm.from);
          console.log("to: " + this.dataForm.to);
          console.log("transYard: " + this.dataForm.transYard);
          console.log("weekDay: " + this.dataForm.weekDay);
          console.log("weekDayDesc: " + this.dataForm.weekDayDesc);
          console.log("occurence: " + this.dataForm.occurence);
          console.log("extTrucker: " + this.dataForm.extTrucker);
          console.log("extTruckerId: " + this.dataForm.extTruckerId);
          console.log("dockType: " + this.dataForm.dockType);
      },

      showSaveData() {
          console.log("group: " + this.saveData.group);
          console.log("tagId: " + this.saveData.tagId);
          console.log("tagName: " + this.saveData.tagName);
          console.log("active: " + this.saveData.active);
          console.log("recWindow: " + this.saveData.recWindow);
          console.log("recWindowDesc: " + this.saveData.recWindowDesc);
          console.log("from: " + this.saveData.from);
          console.log("to: " + this.saveData.to);
          console.log("transYard: " + this.saveData.transYard);
          console.log("weekDay: " + this.saveData.weekDay);
          console.log("weekDayDesc: " + this.saveData.weekDayDesc);
          console.log("occurence: " + this.saveData.occurence);
          console.log("extTrucker: " + this.saveData.extTrucker);
          console.log("extTruckerId: " + this.saveData.extTruckerId);
          console.log("dockType: " + this.saveData.dockType);
      },

      setupSaveData() {
          var apptTime = this.dataForm.from;
          console.log("apptTime: " + apptTime);
          var hour = "";
          var min = "";
          console.log("active: " + this.dataForm.active);
          if (this.dataForm.active != null)    
          {
             this.saveData.active = this.dataForm.active;
             console.log("saveData active: " + this.saveData.active);
          }
          else
             this.saveData.active = true;   
          this.saveData.recWindow = this.dataForm.recWindow;
          if (this.dataForm.recWindowDesc && this.dataForm.recWindowDesc != "")
             this.saveData.recWindowDesc = this.dataForm.recWindowDesc;
          else
             this.saveData.recWindowDesc = this.getMasterDataName("REC_WINDOW",this.dataForm.recWindow);   
          this.saveData.from = this.dataForm.from;
          if (this.dataForm.transYard && this.dataForm.transYard != "")  
             this.saveData.transYard = this.dataForm.transYard;
          else
             this.saveData.transYard = "1010001";
          if (this.dataForm.weekDay && this.dataForm.weekDay != "")      
             this.saveData.weekDay = this.dataForm.weekDay;
          else
             this.saveData.weekDay = "1";
          if (this.dataForm.weekDayDesc && this.dataForm.weekDayDesc != "")      
             this.saveData.weekDayDesc = this.dataForm.weekDayDesc;
          else
             this.saveData.weekDayDesc = "Monday";   
          //this.saveData.occurence = this.dataForm.occurence;
          this.saveData.extTrucker = this.dataForm.extTrucker;
          this.saveData.extTruckerId = this.dataForm.extTruckerId;
          if (this.dataForm.dockType && this.dataForm.dockType != "")      
             this.saveData.dockType = this.dataForm.dockType;
          else
             this.saveData.dockType = "Normal";    
          if (apptTime != null) {
              if (apptTime.indexOf(":") > -1 && apptTime.length >= 1) {
                 console.log("index: " + apptTime.indexOf(":"));
                 hour = apptTime.substr(0,apptTime.indexOf(":"));
                 min = apptTime.substr(apptTime.indexOf(":")+1);
                 console.log("hour: " + hour + " min: " + min);
              }
          }
          var key = this.saveData.transYard + "-";
          key += this.saveData.recWindow + "-" + this.saveData.dockType + "-";
          key += this.saveData.weekDay + "-" + hour + min + "-";
          key += this.saveData.extTruckerId;

          this.saveData.group = this.dataForm.group;
          if (this.dataForm.tagId && this.dataForm.tagId != "")
              this.saveData.tagId = this.dataForm.tagId;
          else
              this.saveData.tagId = key;
          if (this.dataForm.tagName && this.dataForm.tagName != "")
              this.saveData.tagName = this.dataForm.tagName;
          else
              this.saveData.tagName = key;
          if (this.dataForm.to && this.dataForm.to != "")
             this.saveData.to = this.dataForm.to;
          else
          {
              if (hour.length == 1) hour = "0" + hour;
              if (min.length == 1) min = "0" + min;
              this.saveData.to = "2022-01-25T" + hour + ":" + min + ":00";
          } 
      },
 
      doSave() {
        var trucker = this.getMasterDataName("EXT_TRUCKER",this.dataForm.extTruckerId);
        this.dataForm.extTrucker = trucker;
        this.$v.dataForm.$touch();

        this.showinternalData();
        this.setupSaveData();
        this.showSaveData();
        
        /*
        if (this.$v.dataForm.$invalid) {
          console.log("data invalid");
          return;
        }
        */

        //this.$store
        //  .dispatch(
        //    "updateMasterDataGroup",
        //    this.dataForm.group,
        //  ).then( () => {console.log("save Master Data Group" + this.dataForm.group);});

        console.log("save data");
        this.$store
          .dispatch(
            "updateMasterData",
            this.saveData,
          )
          .then(() => {
            console.log("save master data info");
            this.showDialog = false;
            this.onUpdate();
          });
      
      },
    },
  };
</script>
